export var mapIsSelected = function (event, activeEventId) {
    event.isSelected = event.id === activeEventId;
    return event;
};
//# sourceMappingURL=mapIsSelected.js.map